import { render, staticRenderFns } from "./kuaizhao.vue?vue&type=template&id=3c77b994&scoped=true&"
import script from "./kuaizhao.vue?vue&type=script&lang=js&"
export * from "./kuaizhao.vue?vue&type=script&lang=js&"
import style0 from "./kuaizhao.vue?vue&type=style&index=0&id=3c77b994&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77b994",
  null
  
)

export default component.exports